// extracted by mini-css-extract-plugin
export default {"btn_zamowienia_menu_row_green":"OdblokujBTN_btn_zamowienia_menu_row_green__Feu11"};